import { useState } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import styles from './MapRolePage.module.scss'
import { User } from '../../types'
import { useUsers } from '@/features/users'
import { rolesApi } from '@/features/role'
import { toast } from 'sonner'
import MapUserRoleForm from '../../components/MapUserRole/MapUserRoleForm'

export default function MapRolePage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = useParams()

  const userFromState = location.state?.user as User | undefined
  const { data: activeUsers, isLoading: activeLoading } = useUsers(true)

  const user =
    userFromState ?? activeUsers?.find((u) => String(u.id) === String(id))

  const [isMapping, setIsMapping] = useState(false)

  const handleSubmit = async (roleIds: number[]) => {
    if (!user?.id) {
      toast.error('User not found.')
      return
    }

    if (roleIds.length === 0) return

    setIsMapping(true)
    try {
      await rolesApi.mapUserRoles(user.id, roleIds)
      toast.success('Roles mapped successfully.')
      navigate('/users/active')
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ?? err?.message ?? 'Failed to map roles.'
      toast.error(msg)
    } finally {
      setIsMapping(false)
    }
  }

  return (
    <div className={styles.contentWrapper}>
      <button type="button" className={styles.backBtn} onClick={() => navigate(-1)}>
        ‹ Back to Users
      </button>

      {activeLoading && !user ? (
        <div>Loading user...</div>
      ) : !user ? (
        <>
          <p className={styles.error}>User not found. Open this page from the users list.</p>
          <div>
            <button type="button" className={styles.cancelBtn} onClick={() => navigate('/users/active')}>
              Back to users
            </button>
          </div>
        </>
      ) : (
        <MapUserRoleForm
          user={user}
          onCancel={() => navigate('/users/active')}
          onSubmit={handleSubmit}
          isLoading={isMapping}
        />
      )}
    </div>
  )
}
